import { useSelector } from 'react-redux';
import { findQueryClauseSettings, findQuerySettings } from '../../state/shared';

const useClausesCounts = ({
  category,
  code,
  queryUUID,
  dictionaryCode,
}) => useSelector(({ cohorts: { cohorts } }) => {
  const { profile, settings, entities } = findQuerySettings(cohorts, {
    category,
    code,
    queryUUID,
    dictionaryCode,
  });

  return {
    allowCohortCounts: settings.expose_cohort_counts,
    count: profile.totalFiltered,
    entities,
    readErrors: profile.readErrors,
    readStatus: profile.readStatus,
    showCounts: profile.showCounts,
    total: profile.total,
  };
});

const useClauseCounts = ({
  category,
  code,
  queryUUID,
  clauseUUID,
}) => useSelector(({ cohorts: { cohorts } }) => {
  const { profile, settings, entities } = findQueryClauseSettings(cohorts, {
    category, code, queryUUID, clauseUUID,
  });

  return {
    allowCohortCounts: settings.expose_cohort_counts,
    count: profile.totalFiltered,
    entities,
    readErrors: profile.readErrors,
    readStatus: profile.readStatus,
    showCounts: profile.showCounts,
    total: profile.total,
  };
});

const useClauseProfileRows = ({
  category,
  code,
  queryUUID,
  clauseUUID,
}) => useSelector(({ cohorts: { cohorts } }) => {
  const { entities } = findQueryClauseSettings(cohorts, {
    category, code, queryUUID, clauseUUID,
  });

  return { entities };
});

const useClausesProfileRows = ({
  category,
  code,
  queryUUID,
  dictionaryCode,
}) => useSelector(({ cohorts: { cohorts } }) => {
  const { entities } = findQuerySettings(cohorts, {
    category, code, queryUUID, dictionaryCode,
  });

  return { entities };
});

export default {
  useClauseCounts,
  useClausesCounts,
  useClauseProfileRows,
  useClausesProfileRows,
};
